import { IconComponent } from "./icon.component";
import { ModalsComponent } from "./modals.component";
import { ProjectsComponent } from "./projects.component";

const components = [
  IconComponent,
  ProjectsComponent,
  ModalsComponent
];

export function initComponents() {
  for (let i = 0; i < components.length; i++) {
    window.customElements.define(components[i].htmlDefinition, components[i]);
  }
}